import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This is how I connected my Canon DSLR as a webcam",
  "description": "",
  "published": "2017-03-09T00:00:00.000Z",
  "redirect_from": ["/blog/connected-canon-dslr-webcam/swizec/7477"],
  "categories": "Business, Learning, Personal, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Huzzah! It took 3 hours but my new DSLR is now a webcam :D`}<br parentName="p"></br><br parentName="p"></br>{`\\o/`}<br parentName="p"></br><br parentName="p"></br>{`Now all I need are some acting lessons `}<a parentName="p" {...{
          "href": "https://t.co/aeK4J8JO7E"
        }}>{`pic.twitter.com/aeK4J8JO7E`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/839023427658776576"
      }}>{`March 7, 2017`}</a></blockquote>
    <p>{`I will forget how I got this to work, and when I do, I might find this post and remember. You too might want to use a DSLR as a webcam. If so, you're in luck because I'm going to show you how to do it without relying on hacky screen capture tricks.`}</p>
    <p>{`Aren't webcams good enough? Sure. DSLRs are better, though.`}</p>
    <p>{`Why would anyone even want to do this?`}</p>
    <p>{`So the tiny square of your face looks better when you're `}<a parentName="p" {...{
        "href": "https://www.liveedu.tv/swizec/"
      }}>{`livecoding`}</a>{` or screencasting. Very important! Gotta look good on that 200x200 pixel image.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/vsvb0"
        }}>{`Webcam vs. Webcam with studio lighting vs. DSLR as webcam with studio lighting`}</a></p>
    </blockquote>
    <p>{`Also useful for serious coding tutorials (which I want to make more of this year). And if you're super adventurous, you can try to be as cool as `}<a parentName="p" {...{
        "href": "https://www.youtube.com/user/caseyneistat"
      }}>{`Casey Neistat`}</a>{` or `}<a parentName="p" {...{
        "href": "https://www.youtube.com/channel/UCO1cgjhGzsSYb1rsB4bFe4Q"
      }}>{`@mpjme`}</a>{`. But I suspect they actually know what they're doing. ?`}</p>
    <p>{`I don’t… yet. But I have my new `}<a parentName="p" {...{
        "href": "https://www.amazon.com/gp/product/B00T3ER7QO/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00T3ER7QO&linkCode=as2&tag=ageewitahat-20&linkId=3f92596835dff6fba84d21d9bd54f2f0"
      }}>{`Canon EOS Rebel T6i Digital SLR Camera`}</a><img parentName="p" {...{
        "src": "//ir-na.amazon-adsystem.com/e/ir?t=ageewitahat-20&l=am2&o=1&a=B00T3ER7QO",
        "alt": null
      }}></img>{` and I am ready to go!`}</p>
    <h2 {...{
      "id": "heres-how-you-do-it"
    }}>{`Here's how you do it`}</h2>
    <p>{`These instructions work on Macs with a Canon DSLR camera. Some of the software involved relies on the Canon SDK. If you don't have a Canon, this might not work.`}</p>
    <p><strong parentName="p">{`1.`}</strong>{` Go to Github and download this random piece of software. ?`}<a parentName="p" {...{
        "href": "https://github.com/v002/v002-Camera-Live"
      }}>{`Camera Live`}</a></p>
    <p>{`I downloaded the latest zip. You can compile from source, too.`}</p>
    <p>{`Camera Live 2 doesn't even have an icon. Running binaries you find online is totally safe, right?`}</p>
    <p>{`I haven't had any issues ¯`}{`\\`}<em parentName="p">{`(ツ)`}</em>{`/¯`}</p>
    <p><strong parentName="p">{`2.`}</strong>{` Download and install `}<a parentName="p" {...{
        "href": "http://camtwiststudio.com/"
      }}>{`CamTwist`}</a>{`.`}</p>
    <p><strong parentName="p">{`3.`}</strong>{` Run CamTwist, open settings, set fps to 30 and video size to 1920x1080. You can go higher if your camera supports it. My Canon Rebel T6i does not, but it also didn't cost a few grand, so ya know.`}</p>
    <p>{`1920x1080 @ 30 is much better than my webcam that can do 1280x720 @ 30 on a good day.`}</p>
    <p><strong parentName="p">{`4.`}</strong>{` Restart CamTwist.`}</p>
    <p><strong parentName="p">{`5.`}</strong>{` Connect camera to computer. I used the USB cable that came with the base package. I’m getting the HDMI cable by mail soon. Not sure the HDMI cable is better, but it's harder for my bird to bite through.`}</p>
    <p><strong parentName="p">{`You have to do this part every time`}</strong>{` ?`}</p>
    <p><strong parentName="p">{`6.`}</strong>{` Shut down all Canon software.`}</p>
    <p><strong parentName="p">{`7.`}</strong>{` Start Camera Live. It puts your camera in recording mode and starts something called a Syphon server.`}</p>
    <p><strong parentName="p">{`8.`}</strong>{` Start CamTwist, click `}<inlineCode parentName="p">{`View > Main Window`}</inlineCode>{`. Double-click `}<inlineCode parentName="p">{`Syphon`}</inlineCode>{`, choose `}<inlineCode parentName="p">{`Live Server`}</inlineCode>{` as the source.`}</p>
    <p><strong parentName="p">{`9.`}</strong>{` Enjoy your expensive webcam.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      